[
  {
    "date": "2025-12-03 13:00:00",
    "open": 3800,
    "low": 3766.03,
    "high": 3856.41,
    "close": 3818.45,
    "volume": 49856309
  },
  {
    "date": "2025-12-03 14:00:00",
    "open": 3818.45,
    "low": 3771,
    "high": 3844.88,
    "close": 3801.08,
    "volume": 49067503
  },
  {
    "date": "2025-12-03 15:00:00",
    "open": 3801.08,
    "low": 3781.93,
    "high": 3812.92,
    "close": 3795.49,
    "volume": 41370491
  },
  {
    "date": "2025-12-03 16:00:00",
    "open": 3795.49,
    "low": 3650.81,
    "high": 3805.31,
    "close": 3728.5,
    "volume": 40936254
  },
  {
    "date": "2025-12-03 17:00:00",
    "open": 3728.5,
    "low": 3560.64,
    "high": 3744.2,
    "close": 3657.91,
    "volume": 64091531
  },
  {
    "date": "2025-12-03 18:00:00",
    "open": 3657.91,
    "low": 3534.9,
    "high": 3712.02,
    "close": 3583.36,
    "volume": 49670849
  },
  {
    "date": "2025-12-03 19:00:00",
    "open": 3583.36,
    "low": 3508.04,
    "high": 3675.25,
    "close": 3525.31,
    "volume": 45244764
  },
  {
    "date": "2025-12-03 20:00:00",
    "open": 3525.31,
    "low": 3484.37,
    "high": 3554.47,
    "close": 3508.14,
    "volume": 49125705
  },
  {
    "date": "2025-12-03 21:00:00",
    "open": 3508.14,
    "low": 3363.39,
    "high": 3545.27,
    "close": 3440.43,
    "volume": 52979341
  },
  {
    "date": "2025-12-03 22:00:00",
    "open": 3440.43,
    "low": 3430.01,
    "high": 3452.34,
    "close": 3446.86,
    "volume": 54686752
  },
  {
    "date": "2025-12-03 23:00:00",
    "open": 3446.86,
    "low": 3406.41,
    "high": 3484.77,
    "close": 3418.88,
    "volume": 62411082
  },
  {
    "date": "2025-12-04 00:00:00",
    "open": 3418.88,
    "low": 3248.12,
    "high": 3467.54,
    "close": 3362.24,
    "volume": 46320339
  },
  {
    "date": "2025-12-04 01:00:00",
    "open": 3362.24,
    "low": 3303.78,
    "high": 3439.44,
    "close": 3393.53,
    "volume": 46911144
  },
  {
    "date": "2025-12-04 02:00:00",
    "open": 3393.53,
    "low": 3283.36,
    "high": 3442.4,
    "close": 3353.58,
    "volume": 48795816
  },
  {
    "date": "2025-12-04 03:00:00",
    "open": 3353.58,
    "low": 3319.04,
    "high": 3495.77,
    "close": 3403.75,
    "volume": 42891999
  },
  {
    "date": "2025-12-04 04:00:00",
    "open": 3403.75,
    "low": 3398.74,
    "high": 3411.21,
    "close": 3405.12,
    "volume": 51523381
  },
  {
    "date": "2025-12-04 05:00:00",
    "open": 3405.12,
    "low": 3378.15,
    "high": 3423.63,
    "close": 3393.44,
    "volume": 46720934
  },
  {
    "date": "2025-12-04 06:00:00",
    "open": 3393.44,
    "low": 3320.57,
    "high": 3425.89,
    "close": 3326.36,
    "volume": 54657383
  },
  {
    "date": "2025-12-04 07:00:00",
    "open": 3326.36,
    "low": 3306.35,
    "high": 3381.98,
    "close": 3346.05,
    "volume": 49507244
  },
  {
    "date": "2025-12-04 08:00:00",
    "open": 3346.05,
    "low": 3323.42,
    "high": 3381.01,
    "close": 3330.13,
    "volume": 62744324
  },
  {
    "date": "2025-12-04 09:00:00",
    "open": 3330.13,
    "low": 3313.78,
    "high": 3939.55,
    "close": 3577.1,
    "volume": 87890482
  },
  {
    "date": "2025-12-04 10:00:00",
    "open": 3577.1,
    "low": 3573.4,
    "high": 3597.03,
    "close": 3592.86,
    "volume": 47807604
  },
  {
    "date": "2025-12-04 11:00:00",
    "open": 3592.86,
    "low": 3480.4,
    "high": 3668.94,
    "close": 3551.78,
    "volume": 49725700
  },
  {
    "date": "2025-12-04 12:00:00",
    "open": 3551.78,
    "low": 3546.74,
    "high": 3556.46,
    "close": 3551.05,
    "volume": 57627704
  },
  {
    "date": "2025-12-04 13:00:00",
    "open": 3551.05,
    "low": 3402.85,
    "high": 3613.99,
    "close": 3493.96,
    "volume": 45778919
  },
  {
    "date": "2025-12-04 14:00:00",
    "open": 3493.96,
    "low": 3143.25,
    "high": 3756.06,
    "close": 3723.12,
    "volume": 133872146
  },
  {
    "date": "2025-12-04 15:00:00",
    "open": 3723.12,
    "low": 3554.31,
    "high": 3777.26,
    "close": 3667.44,
    "volume": 54314536
  },
  {
    "date": "2025-12-04 16:00:00",
    "open": 3667.44,
    "low": 3592.14,
    "high": 3789.32,
    "close": 3603.97,
    "volume": 40592405
  },
  {
    "date": "2025-12-04 17:00:00",
    "open": 3603.97,
    "low": 3534.24,
    "high": 3683.93,
    "close": 3646.59,
    "volume": 45037065
  },
  {
    "date": "2025-12-04 18:00:00",
    "open": 3646.59,
    "low": 3638.7,
    "high": 3739.93,
    "close": 3677.51,
    "volume": 55944881
  },
  {
    "date": "2025-12-04 19:00:00",
    "open": 3677.51,
    "low": 3631.43,
    "high": 3957.58,
    "close": 3801.34,
    "volume": 104427286
  },
  {
    "date": "2025-12-04 20:00:00",
    "open": 3801.34,
    "low": 3497.21,
    "high": 4056.67,
    "close": 3653.72,
    "volume": 75462623
  },
  {
    "date": "2025-12-04 21:00:00",
    "open": 3653.72,
    "low": 3611.86,
    "high": 3681.16,
    "close": 3633.66,
    "volume": 59323528
  },
  {
    "date": "2025-12-04 22:00:00",
    "open": 3633.66,
    "low": 3606.97,
    "high": 3664.9,
    "close": 3660.31,
    "volume": 54669591
  },
  {
    "date": "2025-12-04 23:00:00",
    "open": 3660.31,
    "low": 3632.99,
    "high": 3688.03,
    "close": 3675.4,
    "volume": 41120384
  },
  {
    "date": "2025-12-05 00:00:00",
    "open": 3675.4,
    "low": 3557,
    "high": 3744.94,
    "close": 3574.78,
    "volume": 126919313
  },
  {
    "date": "2025-12-05 01:00:00",
    "open": 3574.78,
    "low": 3467.38,
    "high": 3610.42,
    "close": 3515.97,
    "volume": 64542454
  },
  {
    "date": "2025-12-05 02:00:00",
    "open": 3515.97,
    "low": 3495.71,
    "high": 3519.85,
    "close": 3505.48,
    "volume": 188430627
  },
  {
    "date": "2025-12-05 03:00:00",
    "open": 3505.48,
    "low": 3489.09,
    "high": 3530.73,
    "close": 3521.52,
    "volume": 61607314
  },
  {
    "date": "2025-12-05 04:00:00",
    "open": 3521.52,
    "low": 3427.36,
    "high": 3588.04,
    "close": 3470.57,
    "volume": 41031846
  },
  {
    "date": "2025-12-05 05:00:00",
    "open": 3470.57,
    "low": 3383.46,
    "high": 3609.36,
    "close": 3522.84,
    "volume": 57501705
  },
  {
    "date": "2025-12-05 06:00:00",
    "open": 3522.84,
    "low": 3441.88,
    "high": 3537.35,
    "close": 3489.42,
    "volume": 48728596
  },
  {
    "date": "2025-12-05 07:00:00",
    "open": 3489.42,
    "low": 3343.78,
    "high": 3535.45,
    "close": 3420.15,
    "volume": 50478606
  },
  {
    "date": "2025-12-05 08:00:00",
    "open": 3420.15,
    "low": 3414.5,
    "high": 3429.25,
    "close": 3422.94,
    "volume": 53448043
  },
  {
    "date": "2025-12-05 09:00:00",
    "open": 3422.94,
    "low": 3320.64,
    "high": 3447.72,
    "close": 3361.07,
    "volume": 56361927
  },
  {
    "date": "2025-12-05 10:00:00",
    "open": 3361.07,
    "low": 3259.51,
    "high": 3376.05,
    "close": 3312.56,
    "volume": 52651188
  },
  {
    "date": "2025-12-05 11:00:00",
    "open": 3312.56,
    "low": 3167.4,
    "high": 3891.67,
    "close": 3506.9,
    "volume": 148382055
  },
  {
    "date": "2025-12-05 12:00:00",
    "open": 3506.9,
    "low": 3477.39,
    "high": 3633.04,
    "close": 3549.6,
    "volume": 54397288
  },
  {
    "date": "2025-12-05 13:00:00",
    "open": 3549.6,
    "low": 3365.92,
    "high": 3659.31,
    "close": 3477.49,
    "volume": 49213055
  },
  {
    "date": "2025-12-05 14:00:00",
    "open": 3477.49,
    "low": 3433.26,
    "high": 3511.61,
    "close": 3455.77,
    "volume": 44222551
  },
  {
    "date": "2025-12-05 15:00:00",
    "open": 3455.77,
    "low": 3281.4,
    "high": 3500.07,
    "close": 3382.37,
    "volume": 52455262
  },
  {
    "date": "2025-12-05 16:00:00",
    "open": 3382.37,
    "low": 3340.11,
    "high": 3515.79,
    "close": 3429.17,
    "volume": 48018541
  },
  {
    "date": "2025-12-05 17:00:00",
    "open": 3429.17,
    "low": 3417.68,
    "high": 3455.49,
    "close": 3443.26,
    "volume": 45784253
  },
  {
    "date": "2025-12-05 18:00:00",
    "open": 3443.26,
    "low": 3426.48,
    "high": 3453.43,
    "close": 3436.27,
    "volume": 45100328
  },
  {
    "date": "2025-12-05 19:00:00",
    "open": 3436.27,
    "low": 3356.46,
    "high": 3521.72,
    "close": 3380.3,
    "volume": 55412277
  },
  {
    "date": "2025-12-05 20:00:00",
    "open": 3380.3,
    "low": 3370.64,
    "high": 3552.99,
    "close": 3438.08,
    "volume": 50877483
  },
  {
    "date": "2025-12-05 21:00:00",
    "open": 3438.08,
    "low": 3245.06,
    "high": 3551.58,
    "close": 3370.45,
    "volume": 80035597
  },
  {
    "date": "2025-12-05 22:00:00",
    "open": 3370.45,
    "low": 3359.72,
    "high": 3476.87,
    "close": 3421.53,
    "volume": 62914045
  },
  {
    "date": "2025-12-05 23:00:00",
    "open": 3421.53,
    "low": 3359.9,
    "high": 3499.71,
    "close": 3472.47,
    "volume": 43474133
  },
  {
    "date": "2025-12-06 00:00:00",
    "open": 3472.47,
    "low": 3459.81,
    "high": 3489.47,
    "close": 3485.88,
    "volume": 59125249
  },
  {
    "date": "2025-12-06 01:00:00",
    "open": 3485.88,
    "low": 3478.19,
    "high": 3505.56,
    "close": 3499.36,
    "volume": 57581035
  },
  {
    "date": "2025-12-06 02:00:00",
    "open": 3499.36,
    "low": 3461.91,
    "high": 3508.12,
    "close": 3469.02,
    "volume": 49463076
  },
  {
    "date": "2025-12-06 03:00:00",
    "open": 3469.02,
    "low": 3437.58,
    "high": 3493.1,
    "close": 3458.5,
    "volume": 60189204
  },
  {
    "date": "2025-12-06 04:00:00",
    "open": 3458.5,
    "low": 3444.58,
    "high": 3472.62,
    "close": 3451.74,
    "volume": 56014714
  },
  {
    "date": "2025-12-06 05:00:00",
    "open": 3451.74,
    "low": 3398.04,
    "high": 3495.59,
    "close": 3484.37,
    "volume": 57535780
  },
  {
    "date": "2025-12-06 06:00:00",
    "open": 3484.37,
    "low": 3429.46,
    "high": 3542.21,
    "close": 3524.99,
    "volume": 57525674
  },
  {
    "date": "2025-12-06 07:00:00",
    "open": 3524.99,
    "low": 3493.84,
    "high": 3596.33,
    "close": 3566.86,
    "volume": 49606866
  },
  {
    "date": "2025-12-06 08:00:00",
    "open": 3566.86,
    "low": 3524.39,
    "high": 3643.34,
    "close": 3596.18,
    "volume": 45339212
  },
  {
    "date": "2025-12-06 09:00:00",
    "open": 3596.18,
    "low": 3443.07,
    "high": 3726.41,
    "close": 3532.42,
    "volume": 51588061
  },
  {
    "date": "2025-12-06 10:00:00",
    "open": 3532.42,
    "low": 3478.7,
    "high": 3631.4,
    "close": 3569.26,
    "volume": 57646056
  },
  {
    "date": "2025-12-06 11:00:00",
    "open": 3569.26,
    "low": 3329.34,
    "high": 3802,
    "close": 3692.95,
    "volume": 174758732
  },
  {
    "date": "2025-12-06 12:00:00",
    "open": 3692.95,
    "low": 3687.34,
    "high": 3706.59,
    "close": 3696.71,
    "volume": 57325259
  },
  {
    "date": "2025-12-06 13:00:00",
    "open": 3696.71,
    "low": 3606.18,
    "high": 3828.93,
    "close": 3755.31,
    "volume": 40027237
  },
  {
    "date": "2025-12-06 14:00:00",
    "open": 3755.31,
    "low": 3737.61,
    "high": 3765.96,
    "close": 3749.6,
    "volume": 62449081
  },
  {
    "date": "2025-12-06 15:00:00",
    "open": 3749.6,
    "low": 3738.18,
    "high": 3799.31,
    "close": 3766.82,
    "volume": 45405879
  },
  {
    "date": "2025-12-06 16:00:00",
    "open": 3766.82,
    "low": 3755.3,
    "high": 3806.77,
    "close": 3790.07,
    "volume": 44166163
  },
  {
    "date": "2025-12-06 17:00:00",
    "open": 3790.07,
    "low": 3683.66,
    "high": 3913.85,
    "close": 3842.89,
    "volume": 43648488
  },
  {
    "date": "2025-12-06 18:00:00",
    "open": 3842.89,
    "low": 3790.81,
    "high": 3919.76,
    "close": 3871.34,
    "volume": 41449302
  },
  {
    "date": "2025-12-06 19:00:00",
    "open": 3871.34,
    "low": 3491.96,
    "high": 4264.33,
    "close": 4076.27,
    "volume": 118477758
  },
  {
    "date": "2025-12-06 20:00:00",
    "open": 4076.27,
    "low": 3930.33,
    "high": 4089.36,
    "close": 4014.12,
    "volume": 61023522
  },
  {
    "date": "2025-12-06 21:00:00",
    "open": 4014.12,
    "low": 3938.77,
    "high": 4115.87,
    "close": 4053.86,
    "volume": 59981642
  },
  {
    "date": "2025-12-06 22:00:00",
    "open": 4053.86,
    "low": 3935.09,
    "high": 4133.84,
    "close": 4009.44,
    "volume": 54871116
  },
  {
    "date": "2025-12-06 23:00:00",
    "open": 4009.44,
    "low": 3620.32,
    "high": 4341.36,
    "close": 4265.64,
    "volume": 140269699
  },
  {
    "date": "2025-12-07 00:00:00",
    "open": 4265.64,
    "low": 4220.5,
    "high": 4339.3,
    "close": 4289.86,
    "volume": 58815336
  },
  {
    "date": "2025-12-07 01:00:00",
    "open": 4289.86,
    "low": 3540.77,
    "high": 5352.02,
    "close": 4722.31,
    "volume": 156236390
  },
  {
    "date": "2025-12-07 02:00:00",
    "open": 4722.31,
    "low": 4697.03,
    "high": 4741.23,
    "close": 4713.53,
    "volume": 62384982
  },
  {
    "date": "2025-12-07 03:00:00",
    "open": 4713.53,
    "low": 4705.29,
    "high": 4802.7,
    "close": 4742.51,
    "volume": 42206951
  },
  {
    "date": "2025-12-07 04:00:00",
    "open": 4742.51,
    "low": 4631.4,
    "high": 4761.03,
    "close": 4691.24,
    "volume": 57159140
  },
  {
    "date": "2025-12-07 05:00:00",
    "open": 4691.24,
    "low": 4675.11,
    "high": 4708.6,
    "close": 4700.45,
    "volume": 55562577
  },
  {
    "date": "2025-12-07 06:00:00",
    "open": 4700.45,
    "low": 4692.15,
    "high": 4739.22,
    "close": 4717.16,
    "volume": 59642721
  },
  {
    "date": "2025-12-07 07:00:00",
    "open": 4717.16,
    "low": 4622.97,
    "high": 4739.29,
    "close": 4662.64,
    "volume": 57069178
  },
  {
    "date": "2025-12-07 08:00:00",
    "open": 4662.64,
    "low": 4551,
    "high": 4771.3,
    "close": 4717.21,
    "volume": 59037751
  },
  {
    "date": "2025-12-07 09:00:00",
    "open": 4717.21,
    "low": 4622.37,
    "high": 4972.45,
    "close": 4804.38,
    "volume": 61627506
  },
  {
    "date": "2025-12-07 10:00:00",
    "open": 4804.38,
    "low": 4737.76,
    "high": 4817.29,
    "close": 4782.75,
    "volume": 58209566
  },
  {
    "date": "2025-12-07 11:00:00",
    "open": 4782.75,
    "low": 4766.22,
    "high": 4807.72,
    "close": 4792.35,
    "volume": 64794781
  },
  {
    "date": "2025-12-07 12:00:00",
    "open": 4792.35,
    "low": 4694.1,
    "high": 4803.81,
    "close": 4742.89,
    "volume": 108865799
  },
  {
    "date": "2025-12-07 13:00:00",
    "open": 4742.89,
    "low": 4726.69,
    "high": 4833.33,
    "close": 4804.39,
    "volume": 55901269
  },
  {
    "date": "2025-12-07 14:00:00",
    "open": 4804.39,
    "low": 4663.46,
    "high": 4925.66,
    "close": 4881.72,
    "volume": 51482462
  },
  {
    "date": "2025-12-07 15:00:00",
    "open": 4881.72,
    "low": 4868.94,
    "high": 4896.62,
    "close": 4886.22,
    "volume": 56368353
  },
  {
    "date": "2025-12-07 16:00:00",
    "open": 4886.22,
    "low": 4860,
    "high": 4966.16,
    "close": 4937.56,
    "volume": 64263528
  },
  {
    "date": "2025-12-07 17:00:00",
    "open": 4937.56,
    "low": 4768.17,
    "high": 5004.12,
    "close": 4841.96,
    "volume": 59877481
  },
  {
    "date": "2025-12-07 18:00:00",
    "open": 4841.96,
    "low": 4770.29,
    "high": 4962.88,
    "close": 4908.06,
    "volume": 64177683
  },
  {
    "date": "2025-12-07 19:00:00",
    "open": 4908.06,
    "low": 4646.72,
    "high": 5026.51,
    "close": 4819.62,
    "volume": 40911818
  },
  {
    "date": "2025-12-07 20:00:00",
    "open": 4819.62,
    "low": 4721.98,
    "high": 4885.61,
    "close": 4772.64,
    "volume": 43161025
  },
  {
    "date": "2025-12-07 21:00:00",
    "open": 4772.64,
    "low": 4693.06,
    "high": 7216,
    "close": 5597.71,
    "volume": 175546278
  },
  {
    "date": "2025-12-07 22:00:00",
    "open": 5597.71,
    "low": 5495.32,
    "high": 5662.12,
    "close": 5551.62,
    "volume": 58946203
  },
  {
    "date": "2025-12-07 23:00:00",
    "open": 5551.62,
    "low": 5455,
    "high": 5612.49,
    "close": 5518.57,
    "volume": 43875181
  },
  {
    "date": "2025-12-08 00:00:00",
    "open": 5518.57,
    "low": 5502.99,
    "high": 5550.55,
    "close": 5543.9,
    "volume": 62373017
  },
  {
    "date": "2025-12-08 01:00:00",
    "open": 5543.9,
    "low": 5522.46,
    "high": 5616.1,
    "close": 5570.86,
    "volume": 41635843
  },
  {
    "date": "2025-12-08 02:00:00",
    "open": 5570.86,
    "low": 5433.31,
    "high": 5731.47,
    "close": 5485.75,
    "volume": 41673328
  },
  {
    "date": "2025-12-08 03:00:00",
    "open": 5485.75,
    "low": 5022.72,
    "high": 5811.33,
    "close": 5305.19,
    "volume": 134638260
  },
  {
    "date": "2025-12-08 04:00:00",
    "open": 5305.19,
    "low": 5270.36,
    "high": 5499.57,
    "close": 5370.3,
    "volume": 48901616
  },
  {
    "date": "2025-12-08 05:00:00",
    "open": 5370.3,
    "low": 4449.95,
    "high": 6150.36,
    "close": 5937.61,
    "volume": 191478741
  },
  {
    "date": "2025-12-08 06:00:00",
    "open": 5937.61,
    "low": 5913.05,
    "high": 5969.07,
    "close": 5947.91,
    "volume": 41036412
  },
  {
    "date": "2025-12-08 07:00:00",
    "open": 5947.91,
    "low": 5840.21,
    "high": 6089.41,
    "close": 5858.6,
    "volume": 59198388
  },
  {
    "date": "2025-12-08 08:00:00",
    "open": 5858.6,
    "low": 5846.73,
    "high": 5866.35,
    "close": 5853.97,
    "volume": 50534356
  },
  {
    "date": "2025-12-08 09:00:00",
    "open": 5853.97,
    "low": 5762.83,
    "high": 5998.03,
    "close": 5920.84,
    "volume": 56656922
  },
  {
    "date": "2025-12-08 10:00:00",
    "open": 5920.84,
    "low": 5862.34,
    "high": 5991.89,
    "close": 5947.97,
    "volume": 64603390
  },
  {
    "date": "2025-12-08 11:00:00",
    "open": 5947.97,
    "low": 5915.79,
    "high": 5958.82,
    "close": 5931.68,
    "volume": 44641981
  },
  {
    "date": "2025-12-08 12:00:00",
    "open": 5931.68,
    "low": 5885,
    "high": 6116.53,
    "close": 6014.78,
    "volume": 62344441
  },
  {
    "date": "2025-12-08 13:00:00",
    "open": 6014.78,
    "low": 5921.3,
    "high": 6044.34,
    "close": 5971.27,
    "volume": 64939013
  },
  {
    "date": "2025-12-08 14:00:00",
    "open": 5971.27,
    "low": 5931.57,
    "high": 5997.74,
    "close": 5957.74,
    "volume": 41956658
  },
  {
    "date": "2025-12-08 15:00:00",
    "open": 5957.74,
    "low": 5813.83,
    "high": 6955.02,
    "close": 6325.58,
    "volume": 134450506
  },
  {
    "date": "2025-12-08 16:00:00",
    "open": 6325.58,
    "low": 6316.18,
    "high": 6333.51,
    "close": 6324.35,
    "volume": 50776506
  },
  {
    "date": "2025-12-08 17:00:00",
    "open": 6324.35,
    "low": 6157.33,
    "high": 6485.33,
    "close": 6426.17,
    "volume": 61300257
  },
  {
    "date": "2025-12-08 18:00:00",
    "open": 6426.17,
    "low": 6403.19,
    "high": 6453.67,
    "close": 6414.84,
    "volume": 58522294
  },
  {
    "date": "2025-12-08 19:00:00",
    "open": 6414.84,
    "low": 5954.19,
    "high": 7287.64,
    "close": 6839.26,
    "volume": 97813372
  },
  {
    "date": "2025-12-08 20:00:00",
    "open": 6839.26,
    "low": 6795.65,
    "high": 7083.6,
    "close": 6935.56,
    "volume": 52917429
  },
  {
    "date": "2025-12-08 21:00:00",
    "open": 6935.56,
    "low": 6527.11,
    "high": 7153.53,
    "close": 6796.3,
    "volume": 49811668
  },
  {
    "date": "2025-12-08 22:00:00",
    "open": 6796.3,
    "low": 6780.16,
    "high": 6830.82,
    "close": 6805.82,
    "volume": 54970446
  },
  {
    "date": "2025-12-08 23:00:00",
    "open": 6805.82,
    "low": 5729.48,
    "high": 7316.88,
    "close": 5801.96,
    "volume": 163856705
  },
  {
    "date": "2025-12-09 00:00:00",
    "open": 5801.96,
    "low": 5747.72,
    "high": 5847.39,
    "close": 5781.95,
    "volume": 62532754
  },
  {
    "date": "2025-12-09 01:00:00",
    "open": 5781.95,
    "low": 5759.29,
    "high": 5809.46,
    "close": 5797.86,
    "volume": 46466907
  },
  {
    "date": "2025-12-09 02:00:00",
    "open": 5797.86,
    "low": 5618.33,
    "high": 5973.26,
    "close": 5893.71,
    "volume": 64519364
  },
  {
    "date": "2025-12-09 03:00:00",
    "open": 5893.71,
    "low": 5827.1,
    "high": 6047.66,
    "close": 5951.84,
    "volume": 176956739
  },
  {
    "date": "2025-12-09 04:00:00",
    "open": 5951.84,
    "low": 5730.5,
    "high": 6089.97,
    "close": 5864.62,
    "volume": 44842623
  },
  {
    "date": "2025-12-09 05:00:00",
    "open": 5864.62,
    "low": 5689.57,
    "high": 5888.74,
    "close": 5793.82,
    "volume": 45593075
  },
  {
    "date": "2025-12-09 06:00:00",
    "open": 5793.82,
    "low": 5702.31,
    "high": 5837.85,
    "close": 5760.05,
    "volume": 58435368
  },
  {
    "date": "2025-12-09 07:00:00",
    "open": 5760.05,
    "low": 5684.94,
    "high": 5892.07,
    "close": 5691.1,
    "volume": 43290387
  },
  {
    "date": "2025-12-09 08:00:00",
    "open": 5691.1,
    "low": 5577.85,
    "high": 5698.99,
    "close": 5647.32,
    "volume": 46168939
  },
  {
    "date": "2025-12-09 09:00:00",
    "open": 5647.32,
    "low": 5576.49,
    "high": 5742.89,
    "close": 5715.19,
    "volume": 56741121
  },
  {
    "date": "2025-12-09 10:00:00",
    "open": 5715.19,
    "low": 5691.12,
    "high": 5724.16,
    "close": 5708.92,
    "volume": 43527172
  },
  {
    "date": "2025-12-09 11:00:00",
    "open": 5708.92,
    "low": 5623.74,
    "high": 5882.47,
    "close": 5793.27,
    "volume": 86451817
  },
  {
    "date": "2025-12-09 12:00:00",
    "open": 5793.27,
    "low": 5757.04,
    "high": 5877.66,
    "close": 5857.79,
    "volume": 187544621
  },
  {
    "date": "2025-12-09 13:00:00",
    "open": 5857.79,
    "low": 5628.6,
    "high": 5914.66,
    "close": 5765.87,
    "volume": 49328227
  },
  {
    "date": "2025-12-09 14:00:00",
    "open": 5765.87,
    "low": 5497.55,
    "high": 5839.24,
    "close": 5658.54,
    "volume": 48640786
  },
  {
    "date": "2025-12-09 15:00:00",
    "open": 5658.54,
    "low": 5429.56,
    "high": 5813.56,
    "close": 5582.81,
    "volume": 56658439
  },
  {
    "date": "2025-12-09 16:00:00",
    "open": 5582.81,
    "low": 4152,
    "high": 6453.97,
    "close": 4944.89,
    "volume": 170731046
  },
  {
    "date": "2025-12-09 17:00:00",
    "open": 4944.89,
    "low": 4829.62,
    "high": 4951.93,
    "close": 4853.82,
    "volume": 43518251
  },
  {
    "date": "2025-12-09 18:00:00",
    "open": 4853.82,
    "low": 4774.23,
    "high": 4918.4,
    "close": 4820.28,
    "volume": 47196984
  },
  {
    "date": "2025-12-09 19:00:00",
    "open": 4820.28,
    "low": 4806.3,
    "high": 4854.6,
    "close": 4830.91,
    "volume": 57683116
  },
  {
    "date": "2025-12-09 20:00:00",
    "open": 4830.91,
    "low": 4738.82,
    "high": 4854.39,
    "close": 4779.17,
    "volume": 40011839
  },
  {
    "date": "2025-12-09 21:00:00",
    "open": 4779.17,
    "low": 4745.71,
    "high": 4787.51,
    "close": 4766.02,
    "volume": 59926833
  },
  {
    "date": "2025-12-09 22:00:00",
    "open": 4766.02,
    "low": 4758.96,
    "high": 4823.62,
    "close": 4809.45,
    "volume": 62529352
  },
  {
    "date": "2025-12-09 23:00:00",
    "open": 4809.45,
    "low": 4724.8,
    "high": 4826.06,
    "close": 4774.91,
    "volume": 59421322
  },
  {
    "date": "2025-12-10 00:00:00",
    "open": 4774.91,
    "low": 4719.48,
    "high": 4864.5,
    "close": 4833.93,
    "volume": 60990198
  },
  {
    "date": "2025-12-10 01:00:00",
    "open": 4833.93,
    "low": 4800.82,
    "high": 4863.82,
    "close": 4852.95,
    "volume": 50194355
  },
  {
    "date": "2025-12-10 02:00:00",
    "open": 4852.95,
    "low": 4739.86,
    "high": 4992.74,
    "close": 4916.51,
    "volume": 61383162
  },
  {
    "date": "2025-12-10 03:00:00",
    "open": 4916.51,
    "low": 4815.82,
    "high": 5024.74,
    "close": 4858.44,
    "volume": 48004376
  },
  {
    "date": "2025-12-10 04:00:00",
    "open": 4858.44,
    "low": 3562.79,
    "high": 5016.82,
    "close": 4426.88,
    "volume": 111366060
  },
  {
    "date": "2025-12-10 05:00:00",
    "open": 4426.88,
    "low": 4390.85,
    "high": 4505.52,
    "close": 4464.68,
    "volume": 50932182
  },
  {
    "date": "2025-12-10 06:00:00",
    "open": 4464.68,
    "low": 4426.53,
    "high": 4552.85,
    "close": 4516.44,
    "volume": 50448451
  },
  {
    "date": "2025-12-10 07:00:00",
    "open": 4516.44,
    "low": 4462.61,
    "high": 4546.36,
    "close": 4498.08,
    "volume": 53111907
  },
  {
    "date": "2025-12-10 08:00:00",
    "open": 4498.08,
    "low": 4234.68,
    "high": 4552.04,
    "close": 4408.46,
    "volume": 58924014
  },
  {
    "date": "2025-12-10 09:00:00",
    "open": 4408.46,
    "low": 4233.91,
    "high": 4558.74,
    "close": 4333.78,
    "volume": 53620388
  },
  {
    "date": "2025-12-10 10:00:00",
    "open": 4333.78,
    "low": 4269.89,
    "high": 4352.56,
    "close": 4309.97,
    "volume": 42883394
  },
  {
    "date": "2025-12-10 11:00:00",
    "open": 4309.97,
    "low": 4267.24,
    "high": 4343.95,
    "close": 4337.51,
    "volume": 80195686
  },
  {
    "date": "2025-12-10 12:00:00",
    "open": 4337.51,
    "low": 4274.79,
    "high": 4390.1,
    "close": 4289.78,
    "volume": 58507526
  },
  {
    "date": "2025-12-10 13:00:00",
    "open": 4289.78,
    "low": 4193.75,
    "high": 4350.85,
    "close": 4219.88,
    "volume": 52754070
  },
  {
    "date": "2025-12-10 14:00:00",
    "open": 4219.88,
    "low": 4100.34,
    "high": 4292.83,
    "close": 4280.08,
    "volume": 47475888
  },
  {
    "date": "2025-12-10 15:00:00",
    "open": 4280.08,
    "low": 4123.35,
    "high": 4384.29,
    "close": 4193.96,
    "volume": 41336539
  },
  {
    "date": "2025-12-10 16:00:00",
    "open": 4193.96,
    "low": 4160.68,
    "high": 4205.47,
    "close": 4176.09,
    "volume": 49543479
  },
  {
    "date": "2025-12-10 17:00:00",
    "open": 4176.09,
    "low": 3981.48,
    "high": 4274.13,
    "close": 4081.81,
    "volume": 59890106
  },
  {
    "date": "2025-12-10 18:00:00",
    "open": 4081.81,
    "low": 4077.33,
    "high": 4092.11,
    "close": 4086.01,
    "volume": 47763033
  },
  {
    "date": "2025-12-10 19:00:00",
    "open": 4086.01,
    "low": 3909.73,
    "high": 4139.83,
    "close": 4022.32,
    "volume": 49132272
  },
  {
    "date": "2025-12-10 20:00:00",
    "open": 4022.32,
    "low": 3936,
    "high": 4128.69,
    "close": 4071.69,
    "volume": 60464854
  },
  {
    "date": "2025-12-10 21:00:00",
    "open": 4071.69,
    "low": 4021.13,
    "high": 4110.79,
    "close": 4041.79,
    "volume": 165273211
  },
  {
    "date": "2025-12-10 22:00:00",
    "open": 4041.79,
    "low": 3881.85,
    "high": 4152.65,
    "close": 3981.09,
    "volume": 50097663
  },
  {
    "date": "2025-12-10 23:00:00",
    "open": 3981.09,
    "low": 3902.41,
    "high": 4050.24,
    "close": 4019.76,
    "volume": 55233282
  },
  {
    "date": "2025-12-11 00:00:00",
    "open": 4019.76,
    "low": 4014.49,
    "high": 4024.95,
    "close": 4020.72,
    "volume": 61488569
  },
  {
    "date": "2025-12-11 01:00:00",
    "open": 4020.72,
    "low": 3911.56,
    "high": 4156.21,
    "close": 4079.51,
    "volume": 64442406
  },
  {
    "date": "2025-12-11 02:00:00",
    "open": 4079.51,
    "low": 4048.13,
    "high": 4179.98,
    "close": 4123.65,
    "volume": 56617979
  },
  {
    "date": "2025-12-11 03:00:00",
    "open": 4123.65,
    "low": 3190.21,
    "high": 4319.41,
    "close": 3649.59,
    "volume": 136466886
  },
  {
    "date": "2025-12-11 04:00:00",
    "open": 3649.59,
    "low": 3579.17,
    "high": 3695.98,
    "close": 3621.29,
    "volume": 44116071
  },
  {
    "date": "2025-12-11 05:00:00",
    "open": 3621.29,
    "low": 3539.38,
    "high": 3704.65,
    "close": 3688.36,
    "volume": 45983346
  },
  {
    "date": "2025-12-11 06:00:00",
    "open": 3688.36,
    "low": 3358.12,
    "high": 3939.89,
    "close": 3424.76,
    "volume": 116096507
  },
  {
    "date": "2025-12-11 07:00:00",
    "open": 3424.76,
    "low": 3331.72,
    "high": 3530.18,
    "close": 3359.42,
    "volume": 50618313
  },
  {
    "date": "2025-12-11 08:00:00",
    "open": 3359.42,
    "low": 3328.86,
    "high": 3370.83,
    "close": 3349.6,
    "volume": 58956856
  },
  {
    "date": "2025-12-11 09:00:00",
    "open": 3349.6,
    "low": 3329.94,
    "high": 3381.07,
    "close": 3359.57,
    "volume": 82681527
  },
  {
    "date": "2025-12-11 10:00:00",
    "open": 3359.57,
    "low": 3355,
    "high": 3364.19,
    "close": 3358.84,
    "volume": 137372750
  },
  {
    "date": "2025-12-11 11:00:00",
    "open": 3358.84,
    "low": 3090.17,
    "high": 3618.77,
    "close": 3491.86,
    "volume": 121035355
  },
  {
    "date": "2025-12-11 12:00:00",
    "open": 3491.86,
    "low": 3433.51,
    "high": 3568.35,
    "close": 3543.46,
    "volume": 49980404
  },
  {
    "date": "2025-12-11 13:00:00",
    "open": 3543.46,
    "low": 3500.47,
    "high": 3565.85,
    "close": 3519.82,
    "volume": 52388621
  },
  {
    "date": "2025-12-11 14:00:00",
    "open": 3519.82,
    "low": 3474.79,
    "high": 3605.32,
    "close": 3478.57,
    "volume": 50672505
  },
  {
    "date": "2025-12-11 15:00:00",
    "open": 3478.57,
    "low": 3218.91,
    "high": 4186.01,
    "close": 3915.74,
    "volume": 121998439
  },
  {
    "date": "2025-12-11 16:00:00",
    "open": 3915.74,
    "low": 3864.72,
    "high": 4091.91,
    "close": 3976.27,
    "volume": 55802479
  },
  {
    "date": "2025-12-11 17:00:00",
    "open": 3976.27,
    "low": 3514.49,
    "high": 4009.02,
    "close": 3813.29,
    "volume": 126627114
  },
  {
    "date": "2025-12-11 18:00:00",
    "open": 3813.29,
    "low": 3769.2,
    "high": 3836.92,
    "close": 3793.76,
    "volume": 44782035
  },
  {
    "date": "2025-12-11 19:00:00",
    "open": 3793.76,
    "low": 3769.49,
    "high": 3820.64,
    "close": 3804.77,
    "volume": 59108214
  },
  {
    "date": "2025-12-11 20:00:00",
    "open": 3804.77,
    "low": 3736.23,
    "high": 3919.21,
    "close": 3891.9,
    "volume": 40956933
  },
  {
    "date": "2025-12-11 21:00:00",
    "open": 3891.9,
    "low": 3860.59,
    "high": 3907.45,
    "close": 3869.78,
    "volume": 54649984
  },
  {
    "date": "2025-12-11 22:00:00",
    "open": 3869.78,
    "low": 3768.44,
    "high": 3894.38,
    "close": 3837.25,
    "volume": 50045832
  },
  {
    "date": "2025-12-11 23:00:00",
    "open": 3837.25,
    "low": 3751.05,
    "high": 4141.3,
    "close": 3994.84,
    "volume": 111807351
  },
  {
    "date": "2025-12-12 00:00:00",
    "open": 3994.84,
    "low": 3981.65,
    "high": 4034.32,
    "close": 4008.75,
    "volume": 56656492
  },
  {
    "date": "2025-12-12 01:00:00",
    "open": 4008.75,
    "low": 3777.36,
    "high": 4110.89,
    "close": 3919.03,
    "volume": 129110182
  },
  {
    "date": "2025-12-12 02:00:00",
    "open": 3919.03,
    "low": 3850,
    "high": 3942.56,
    "close": 3894.73,
    "volume": 62080256
  },
  {
    "date": "2025-12-12 03:00:00",
    "open": 3894.73,
    "low": 3692.92,
    "high": 4023.08,
    "close": 3825.38,
    "volume": 59044956
  },
  {
    "date": "2025-12-12 04:00:00",
    "open": 3825.38,
    "low": 3616.23,
    "high": 3907.87,
    "close": 3749.96,
    "volume": 51085302
  },
  {
    "date": "2025-12-12 05:00:00",
    "open": 3749.96,
    "low": 3696.03,
    "high": 3789.92,
    "close": 3716.12,
    "volume": 41880037
  },
  {
    "date": "2025-12-12 06:00:00",
    "open": 3716.12,
    "low": 3700.84,
    "high": 3823.83,
    "close": 3776.45,
    "volume": 40820113
  },
  {
    "date": "2025-12-12 07:00:00",
    "open": 3776.45,
    "low": 3741.9,
    "high": 3823.95,
    "close": 3793.24,
    "volume": 42126071
  },
  {
    "date": "2025-12-12 08:00:00",
    "open": 3793.24,
    "low": 3764.8,
    "high": 3889.27,
    "close": 3864.78,
    "volume": 62891128
  },
  {
    "date": "2025-12-12 09:00:00",
    "open": 3864.78,
    "low": 3830.44,
    "high": 3992.84,
    "close": 3933.54,
    "volume": 48120173
  },
  {
    "date": "2025-12-12 10:00:00",
    "open": 3933.54,
    "low": 3904.2,
    "high": 3972.18,
    "close": 3947.48,
    "volume": 52015525
  },
  {
    "date": "2025-12-12 11:00:00",
    "open": 3947.48,
    "low": 3936.36,
    "high": 3971.15,
    "close": 3961.34,
    "volume": 47206357
  },
  {
    "date": "2025-12-12 12:00:00",
    "open": 3961.34,
    "low": 3953.62,
    "high": 3966.32,
    "close": 3960.04,
    "volume": 56850585
  },
  {
    "date": "2025-12-12 13:00:00",
    "open": 3960.04,
    "low": 3875.16,
    "high": 4024.02,
    "close": 3927.97,
    "volume": 63867356
  },
  {
    "date": "2025-12-12 14:00:00",
    "open": 3927.97,
    "low": 3901.32,
    "high": 3945.88,
    "close": 3909.69,
    "volume": 46972048
  },
  {
    "date": "2025-12-12 15:00:00",
    "open": 3909.69,
    "low": 3891.18,
    "high": 3923.86,
    "close": 3903.46,
    "volume": 50561520
  },
  {
    "date": "2025-12-12 16:00:00",
    "open": 3903.46,
    "low": 3895.81,
    "high": 3907.48,
    "close": 3900.97,
    "volume": 42769304
  },
  {
    "date": "2025-12-12 17:00:00",
    "open": 3900.97,
    "low": 3814.06,
    "high": 3907.37,
    "close": 3865.64,
    "volume": 54708686
  },
  {
    "date": "2025-12-12 18:00:00",
    "open": 3865.64,
    "low": 3819.59,
    "high": 3875.69,
    "close": 3846.5,
    "volume": 47461584
  },
  {
    "date": "2025-12-12 19:00:00",
    "open": 3846.5,
    "low": 3443.48,
    "high": 4166.29,
    "close": 3674.82,
    "volume": 180916560
  },
  {
    "date": "2025-12-12 20:00:00",
    "open": 3674.82,
    "low": 3550.88,
    "high": 3736.97,
    "close": 3614.58,
    "volume": 60137068
  },
  {
    "date": "2025-12-12 21:00:00",
    "open": 3614.58,
    "low": 3510.9,
    "high": 3759.96,
    "close": 3665.86,
    "volume": 58928787
  },
  {
    "date": "2025-12-12 22:00:00",
    "open": 3665.86,
    "low": 3576.35,
    "high": 3684.7,
    "close": 3629.23,
    "volume": 55053487
  },
  {
    "date": "2025-12-12 23:00:00",
    "open": 3629.23,
    "low": 3507.1,
    "high": 3758.45,
    "close": 3693.53,
    "volume": 46343939
  },
  {
    "date": "2025-12-13 00:00:00",
    "open": 3693.53,
    "low": 3621.24,
    "high": 3702.2,
    "close": 3662.14,
    "volume": 43440585
  },
  {
    "date": "2025-12-13 01:00:00",
    "open": 3662.14,
    "low": 3635.26,
    "high": 3721.86,
    "close": 3682.36,
    "volume": 42717425
  },
  {
    "date": "2025-12-13 02:00:00",
    "open": 3682.36,
    "low": 3658.57,
    "high": 3710.07,
    "close": 3692.51,
    "volume": 56347489
  },
  {
    "date": "2025-12-13 03:00:00",
    "open": 3692.51,
    "low": 3580.46,
    "high": 3713.96,
    "close": 3650.19,
    "volume": 49422963
  },
  {
    "date": "2025-12-13 04:00:00",
    "open": 3650.19,
    "low": 3464.27,
    "high": 4117.37,
    "close": 3829.91,
    "volume": 70566052
  },
  {
    "date": "2025-12-13 05:00:00",
    "open": 3829.91,
    "low": 3718.53,
    "high": 3835.15,
    "close": 3757.08,
    "volume": 50726059
  },
  {
    "date": "2025-12-13 06:00:00",
    "open": 3757.08,
    "low": 3702.78,
    "high": 3821.4,
    "close": 3790.38,
    "volume": 62113483
  },
  {
    "date": "2025-12-13 07:00:00",
    "open": 3790.38,
    "low": 3781.6,
    "high": 3899.4,
    "close": 3848.76,
    "volume": 49102333
  },
  {
    "date": "2025-12-13 08:00:00",
    "open": 3848.76,
    "low": 3598.81,
    "high": 4166.81,
    "close": 4082.87,
    "volume": 180133581
  },
  {
    "date": "2025-12-13 09:00:00",
    "open": 4082.87,
    "low": 3957.9,
    "high": 4107.76,
    "close": 4020.3,
    "volume": 49652311
  },
  {
    "date": "2025-12-13 10:00:00",
    "open": 4020.3,
    "low": 3893.35,
    "high": 4027.88,
    "close": 3958.7,
    "volume": 63780818
  },
  {
    "date": "2025-12-13 11:00:00",
    "open": 3958.7,
    "low": 3951.37,
    "high": 3965.06,
    "close": 3960.57,
    "volume": 49234260
  },
  {
    "date": "2025-12-13 12:00:00",
    "open": 3960.57,
    "low": 3952.26,
    "high": 3976.54,
    "close": 3965.28,
    "volume": 43139781
  },
  {
    "date": "2025-12-13 13:00:00",
    "open": 3965.28,
    "low": 3955.81,
    "high": 4061.93,
    "close": 4029.92,
    "volume": 42014307
  },
  {
    "date": "2025-12-13 14:00:00",
    "open": 4029.92,
    "low": 3964.27,
    "high": 4189.56,
    "close": 4112.44,
    "volume": 44148203
  },
  {
    "date": "2025-12-13 15:00:00",
    "open": 4112.44,
    "low": 4039.5,
    "high": 4160.94,
    "close": 4154.41,
    "volume": 48106903
  },
  {
    "date": "2025-12-13 16:00:00",
    "open": 4154.41,
    "low": 4091.05,
    "high": 4197.71,
    "close": 4118.87,
    "volume": 56585751
  },
  {
    "date": "2025-12-13 17:00:00",
    "open": 4118.87,
    "low": 4068.03,
    "high": 4227.83,
    "close": 4165.42,
    "volume": 48557148
  },
  {
    "date": "2025-12-13 18:00:00",
    "open": 4165.42,
    "low": 4056.15,
    "high": 4197.34,
    "close": 4098.07,
    "volume": 54606312
  },
  {
    "date": "2025-12-13 19:00:00",
    "open": 4098.07,
    "low": 4001.91,
    "high": 4241.69,
    "close": 4169.08,
    "volume": 54914910
  },
  {
    "date": "2025-12-13 20:00:00",
    "open": 4169.08,
    "low": 4128.06,
    "high": 4209.43,
    "close": 4191.84,
    "volume": 41043694
  },
  {
    "date": "2025-12-13 21:00:00",
    "open": 4191.84,
    "low": 4185.08,
    "high": 4199.66,
    "close": 4193.51,
    "volume": 43381903
  },
  {
    "date": "2025-12-13 22:00:00",
    "open": 4193.51,
    "low": 4105.99,
    "high": 4317.57,
    "close": 4247.05,
    "volume": 52357858
  },
  {
    "date": "2025-12-13 23:00:00",
    "open": 4247.05,
    "low": 4097.14,
    "high": 4270.23,
    "close": 4177.48,
    "volume": 54267770
  },
  {
    "date": "2025-12-14 00:00:00",
    "open": 4177.48,
    "low": 4160.14,
    "high": 4272.14,
    "close": 4251.31,
    "volume": 52771891
  },
  {
    "date": "2025-12-14 01:00:00",
    "open": 4251.31,
    "low": 4140.59,
    "high": 4355.96,
    "close": 4322.31,
    "volume": 51894911
  },
  {
    "date": "2025-12-14 02:00:00",
    "open": 4322.31,
    "low": 4190.16,
    "high": 4491.9,
    "close": 4412.67,
    "volume": 59252727
  },
  {
    "date": "2025-12-14 03:00:00",
    "open": 4412.67,
    "low": 4388.71,
    "high": 4428.34,
    "close": 4405.93,
    "volume": 43090746
  },
  {
    "date": "2025-12-14 04:00:00",
    "open": 4405.93,
    "low": 4368.46,
    "high": 4539.12,
    "close": 4466.23,
    "volume": 61798375
  },
  {
    "date": "2025-12-14 05:00:00",
    "open": 4466.23,
    "low": 4416.94,
    "high": 4703.84,
    "close": 4549.38,
    "volume": 56454220
  },
  {
    "date": "2025-12-14 06:00:00",
    "open": 4549.38,
    "low": 4543.27,
    "high": 4555.51,
    "close": 4548.06,
    "volume": 49076747
  },
  {
    "date": "2025-12-14 07:00:00",
    "open": 4548.06,
    "low": 4510.41,
    "high": 4566.48,
    "close": 4533.44,
    "volume": 44690793
  },
  {
    "date": "2025-12-14 08:00:00",
    "open": 4533.44,
    "low": 4492.39,
    "high": 4570.31,
    "close": 4559.5,
    "volume": 44393061
  },
  {
    "date": "2025-12-14 09:00:00",
    "open": 4559.5,
    "low": 4356.15,
    "high": 5498.26,
    "close": 4874.39,
    "volume": 89073945
  },
  {
    "date": "2025-12-14 10:00:00",
    "open": 4874.39,
    "low": 4751.44,
    "high": 4935.5,
    "close": 4792.91,
    "volume": 58935834
  },
  {
    "date": "2025-12-14 11:00:00",
    "open": 4792.91,
    "low": 4742.46,
    "high": 4856.15,
    "close": 4822.06,
    "volume": 52093017
  },
  {
    "date": "2025-12-14 12:00:00",
    "open": 4822.06,
    "low": 4806.13,
    "high": 4944.13,
    "close": 4863.87,
    "volume": 58100239
  },
  {
    "date": "2025-12-14 13:00:00",
    "open": 4863.87,
    "low": 4834.65,
    "high": 4997.93,
    "close": 4927.66,
    "volume": 58795745
  },
  {
    "date": "2025-12-14 14:00:00",
    "open": 4927.66,
    "low": 4916.56,
    "high": 4932.85,
    "close": 4924.42,
    "volume": 47093025
  },
  {
    "date": "2025-12-14 15:00:00",
    "open": 4924.42,
    "low": 4901.76,
    "high": 4946.74,
    "close": 4938.54,
    "volume": 59796644
  },
  {
    "date": "2025-12-14 16:00:00",
    "open": 4938.54,
    "low": 4933.3,
    "high": 4957.22,
    "close": 4943.17,
    "volume": 40677830
  },
  {
    "date": "2025-12-14 17:00:00",
    "open": 4943.17,
    "low": 4819.51,
    "high": 5106.58,
    "close": 5036.09,
    "volume": 52929438
  },
  {
    "date": "2025-12-14 18:00:00",
    "open": 5036.09,
    "low": 5002.57,
    "high": 5098.95,
    "close": 5075.15,
    "volume": 64643760
  },
  {
    "date": "2025-12-14 19:00:00",
    "open": 5075.15,
    "low": 5069.03,
    "high": 5090.85,
    "close": 5079.08,
    "volume": 43719791
  },
  {
    "date": "2025-12-14 20:00:00",
    "open": 5079.08,
    "low": 5015.78,
    "high": 5179.63,
    "close": 5031.06,
    "volume": 61809456
  },
  {
    "date": "2025-12-14 21:00:00",
    "open": 5031.06,
    "low": 4903.13,
    "high": 5109.1,
    "close": 4959.4,
    "volume": 63034591
  },
  {
    "date": "2025-12-14 22:00:00",
    "open": 4959.4,
    "low": 4885.61,
    "high": 5105.35,
    "close": 5049.83,
    "volume": 41532940
  },
  {
    "date": "2025-12-14 23:00:00",
    "open": 5049.83,
    "low": 4963.45,
    "high": 5109.64,
    "close": 5095.38,
    "volume": 44655516
  },
  {
    "date": "2025-12-15 00:00:00",
    "open": 5095.38,
    "low": 5070.23,
    "high": 5121.83,
    "close": 5108.75,
    "volume": 62875130
  },
  {
    "date": "2025-12-15 01:00:00",
    "open": 5108.75,
    "low": 4539.28,
    "high": 6728.83,
    "close": 5725.72,
    "volume": 135058787
  },
  {
    "date": "2025-12-15 02:00:00",
    "open": 5725.72,
    "low": 5578.74,
    "high": 5789.55,
    "close": 5665.28,
    "volume": 40878995
  },
  {
    "date": "2025-12-15 03:00:00",
    "open": 5665.28,
    "low": 5506.97,
    "high": 5761.49,
    "close": 5593.02,
    "volume": 73439600
  },
  {
    "date": "2025-12-15 04:00:00",
    "open": 5593.02,
    "low": 5345.97,
    "high": 5686.27,
    "close": 5504.78,
    "volume": 53136089
  },
  {
    "date": "2025-12-15 05:00:00",
    "open": 5504.78,
    "low": 5303.67,
    "high": 5547.51,
    "close": 5433.4,
    "volume": 50962149
  },
  {
    "date": "2025-12-15 06:00:00",
    "open": 5433.4,
    "low": 5427.59,
    "high": 5453.01,
    "close": 5439.94,
    "volume": 40033589
  },
  {
    "date": "2025-12-15 07:00:00",
    "open": 5439.94,
    "low": 5221.67,
    "high": 6127.07,
    "close": 5839.03,
    "volume": 175640309
  },
  {
    "date": "2025-12-15 08:00:00",
    "open": 5839.03,
    "low": 5766.17,
    "high": 5883.39,
    "close": 5813.38,
    "volume": 63468009
  },
  {
    "date": "2025-12-15 09:00:00",
    "open": 5813.38,
    "low": 5653.72,
    "high": 5949.17,
    "close": 5722.86,
    "volume": 62634876
  },
  {
    "date": "2025-12-15 10:00:00",
    "open": 5722.86,
    "low": 5707.07,
    "high": 5771.97,
    "close": 5738.13,
    "volume": 52114482
  },
  {
    "date": "2025-12-15 11:00:00",
    "open": 5738.13,
    "low": 5595.92,
    "high": 5835.19,
    "close": 5683.19,
    "volume": 62208674
  },
  {
    "date": "2025-12-15 12:00:00",
    "open": 5683.19,
    "low": 5103.08,
    "high": 6288.89,
    "close": 6060.37,
    "volume": 103320204
  },
  {
    "date": "2025-12-15 13:00:00",
    "open": 6060.37,
    "low": 6052.68,
    "high": 6068.85,
    "close": 6059.05,
    "volume": 61806571
  },
  {
    "date": "2025-12-15 14:00:00",
    "open": 6059.05,
    "low": 5900.08,
    "high": 6131.73,
    "close": 6003.32,
    "volume": 49383607
  },
  {
    "date": "2025-12-15 15:00:00",
    "open": 6003.32,
    "low": 5967.1,
    "high": 6017.39,
    "close": 5975.97,
    "volume": 43515515
  },
  {
    "date": "2025-12-15 16:00:00",
    "open": 5975.97,
    "low": 5855.6,
    "high": 6060.36,
    "close": 5885.38,
    "volume": 53550016
  },
  {
    "date": "2025-12-15 17:00:00",
    "open": 5885.38,
    "low": 5832.78,
    "high": 5910.85,
    "close": 5853.98,
    "volume": 46361670
  },
  {
    "date": "2025-12-15 18:00:00",
    "open": 5853.98,
    "low": 5843.65,
    "high": 5863.55,
    "close": 5852.05,
    "volume": 49787337
  },
  {
    "date": "2025-12-15 19:00:00",
    "open": 5852.05,
    "low": 5820.33,
    "high": 5909.44,
    "close": 5871.44,
    "volume": 59778680
  },
  {
    "date": "2025-12-15 20:00:00",
    "open": 5871.44,
    "low": 5806.26,
    "high": 6011.53,
    "close": 5923.76,
    "volume": 59521495
  },
  {
    "date": "2025-12-15 21:00:00",
    "open": 5923.76,
    "low": 5473.71,
    "high": 6127.93,
    "close": 5632.27,
    "volume": 96017982
  },
  {
    "date": "2025-12-15 22:00:00",
    "open": 5632.27,
    "low": 4300.51,
    "high": 6273.25,
    "close": 5178.47,
    "volume": 172569842
  },
  {
    "date": "2025-12-15 23:00:00",
    "open": 5178.47,
    "low": 5067.41,
    "high": 5274.67,
    "close": 5089.93,
    "volume": 64648104
  },
  {
    "date": "2025-12-16 00:00:00",
    "open": 5089.93,
    "low": 5016.52,
    "high": 5188.61,
    "close": 5031.53,
    "volume": 41394119
  }
]